import calls from '@/backend/api-calls'

const state = () => ({
  fabrications: [],
  fabricationTypes: [],
  selected: [],
  allSelected: false,
  loading: false,
  typesLoading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.fabrications.map(d => d.id);
  }
}

// actions
const actions = {
  getFabrications: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.fabrications.get(parameters)
        .then(resp => {
          commit("setFabrications", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addFabrication: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.fabrications.post(data)
        .then(resp => {
          commit("insertFabrication", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateFabrication: ({commit}, { fabricationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.fabrication.put(fabricationId, data)
        .then(resp => {
          commit("insertUpdatedFabrication", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteFabrication: ({commit}, fabricationId) => {
    return new Promise((resolve, reject) => {
      calls.fabrication.delete(fabricationId)
        .then(resp => {
          commit("removeFabrication", fabricationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Fabrication successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  },
  getFabricationTypes: ({commit}, parameters) => {
    commit("setTypesLoading", true);
    return new Promise((resolve, reject) => {
      calls.fabricationTypes.get(parameters)
        .then(resp => {
          commit("setFabricationTypes", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addFabricationType: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.fabricationTypes.post(data)
        .then(resp => {
          commit("insertFabricationType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateFabricationType: ({commit}, { fabricationTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.fabricationType.put(fabricationTypeId, data)
        .then(resp => {
          commit("insertUpdatedFabricationType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteFabricationType: ({commit}, fabricationTypeId) => {
    return new Promise((resolve, reject) => {
      calls.fabricationType.delete(fabricationTypeId)
        .then(resp => {
          commit("removeFabricationType", fabricationTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Fabrication type successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFabrications (state, data) {
    state.fabrications = data.results;
    state.pagination = data.pagination;
  },
  insertFabrication (state, data) {
    state.fabrications.push(data);
  },
  insertUpdatedFabrication (state, data) {
    state.fabrications.forEach((fabrication, i) => {
      if (fabrication.id == data.id) {
        state.fabrications.splice(i, 1, data);
      }
    })
  },
  removeFabrication (state, id) {
    state.fabrications.forEach((fabrication, i) => {
      if (fabrication.id == id) {
        state.fabrications.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  // Fabrication Types
  setTypesLoading(state, status) {
    state.typesLoading = status;
  },
  setFabricationTypes (state, data) {
    state.fabricationTypes = data.results;
  },
  insertFabricationType (state, data) {
    state.fabricationTypes.push(data);
  },
  insertUpdatedFabricationType (state, data) {
    state.fabricationType.forEach((type, i) => {
      if (type.id == data.id) {
        state.fabricationTypes.splice(i, 1, data);
      }
    })
  },
  removeFabricationType (state, id) {
    state.fabricationTypes.forEach((type, i) => {
      if (type.id == id) {
        state.fabricationTypes.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}